module.exports = __webpack_public_path__ + "static/media/Shahin Ali.55252108.jpg";